import React from 'react';
import classNames from 'classnames';
import { Button, Colors, Display, Sizes } from 'Views/Components/Button/Button';
import Icon from 'Views/Components/_HumanWritten/Icon/Icon';

interface AddNewCustomerButtonProps {
	onClick: () => void;
	className?: string;
}

/**
 * Small trigger rendered under a customer search input so staff can register a new customer
 * without leaving the current flow.
 */
export function AddNewCustomerButton({ onClick, className }: AddNewCustomerButtonProps) {
	return (
		<Button
			className={classNames('add-new-customer-btn', className)}
			display={Display.Text}
			colors={Colors.Secondary}
			sizes={Sizes.Small}
			newStyles
			onClick={onClick}
			buttonProps={{ 'data-test-id': 'add-new-customer-button' } as any}
		>
			<Icon name="person_add" useMaterialIcons />
			Add new
		</Button>
	);
}
